<app-center-section>
  <h1>{{ title }}</h1>
  <div [innerHTML]="body | sanitizeHtml" class="rich-text"></div>
  <app-text-button (click)="changeConsent()">{{ changeConsentLabel }}</app-text-button>
</app-center-section>
